export const sourceIconWhite = (source: string) => {
  const trimSource = source?.trim().toLocaleLowerCase();
  switch (trimSource) {
    case 'website':
      return '/vertical-seesight-logo.png';
      break;
    case 'google':
      return 'https://res.cloudinary.com/see-sight-tours/image/upload/v1685535923/Remaining%20images/Landing/Google_gehx1m.svg';
      break;
    case 'expedia':
      return 'https://res.cloudinary.com/see-sight-tours/image/upload/v1685535945/Remaining%20images/Landing/Expedia_awoxne.svg';
      break;
    case 'tripadvisor':
      return 'https://res.cloudinary.com/see-sight-tours/image/upload/v1645034046/logos/Tripadvisor_Logo_circle-green_vertical-lockup_registered_RGB_iclyaj.svg';
      break;
    case 'viator':
      return 'https://res.cloudinary.com/see-sight-tours/image/upload/v1685535956/Remaining%20images/Landing/Viator_gf4bi0.svg';
      break;
    case 'getyourguide':
      return 'https://res.cloudinary.com/see-sight-tours/image/upload/v1689160041/Remaining%20images/Landing/GYG_SVG_tavy8s.svg';
      break;
    default:
      return 'https://res.cloudinary.com/see-sight-tours/image/upload/v1685535923/Remaining%20images/Landing/Google_gehx1m.svg';
  }
};

export const sourceIcon = (source: string) => {
  const trimSource = source?.trim().toLocaleLowerCase();
  switch (trimSource) {
    case 'website':
      return '/vertical-seesight-logo.png';
      break;
    case 'google':
      return 'https://res.cloudinary.com/see-sight-tours/image/upload/v1684499413/icons-website/Logos_SVG-03_qo1jz2.svg';
      break;
    case 'expedia':
      return 'https://res.cloudinary.com/see-sight-tours/image/upload/v1684499413/icons-website/Logos_SVG-02_v768ee.svg';
      break;
    case 'tripadvisor':
      return 'https://res.cloudinary.com/see-sight-tours/image/upload/v1645034046/logos/Tripadvisor_Logo_circle-green_vertical-lockup_registered_RGB_iclyaj.svg';
      break;
    case 'viator':
      return '/Viator-Logo.svg';
      break;
    case 'getyourguide':
      return 'https://res.cloudinary.com/see-sight-tours/image/upload/v1704272037/63d1baf89ce0eb1c6c688ec0_getyourguide_logo_d18jtl.png';
      break;
    case 'get your guide':
      return 'https://res.cloudinary.com/see-sight-tours/image/upload/v1704272037/63d1baf89ce0eb1c6c688ec0_getyourguide_logo_d18jtl.png';
      break;
    case null:
      return 'https://res.cloudinary.com/see-sight-tours/image/upload/v1704271783/icons-website/qohiuloz15d3si2idy5d.png';
      break;
    default:
      return '/vertical-seesight-logo.png';
  }
};
